import axios from "axios";

export const BACKEND_MAIN_URL = "https://api-robots.herokuapp.com/";

export const fetchAnalytics = (set) => {
    fetch(`${BACKEND_MAIN_URL}analytics`)
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            set(data.analyticsData);
        })
        .catch(() => {
            console.log("error");
        });
};

export const fetchBackendUserData = async (account, set) => {
    if (account) {
        const result = await axios(`${BACKEND_MAIN_URL}robots?bscUserAddress=${account}`);
        set(result.data);
    }
};

export const fetchBackendUserHistory = async (account, set) => {
    if (account) {
        const result = await axios(`${BACKEND_MAIN_URL}robots/history?userBscAddress=${account}`);
        set(result.data);
    }
};

export const fetchPredictPools= async (account, set) => {
    if (account) {
        const result = await axios(`${BACKEND_MAIN_URL}robots/immutable/predict?bscUserAddress=${account}`);
        set(result.data);
    }
};

export default null;